import { useEffect, useState } from "react";
import { PhoneIncoming, PhoneOutgoing, Search } from "lucide-react";
import { apiGet } from "@/lib/apiAdmin";
import { HUD } from "./theme";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/Phoenix", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "");

const Call = ({ c }) => {
  const [open, setOpen] = useState(false);
  const Icon = c.direction === "outbound" ? PhoneOutgoing : PhoneIncoming;
  return (
    <div className="p-2 space-y-1" data-testid={`jarvis-call-${c.call_id}`}>
      <div className="flex items-center gap-2">
        <Icon className={`w-3.5 h-3.5 ${c.direction === "outbound" ? "text-cyan-300" : "text-emerald-300"}`} />
        <span className="text-white">{c.direction === "outbound" ? "JARVIS called" : "Called in"}</span>
        <span className="text-gray-500">{when(c.created_at)}</span>
        {c.caller_type === "team" && <span className="text-[10px] px-1.5 rounded border border-cyan-400/30 text-cyan-300">team</span>}
      </div>
      <p className="text-gray-300">{c.summary || (c.objective ? `Goal: ${c.objective.split("\n")[0]}` : "No summary")}{c.status === "failed" && <span className="text-rose-300"> · call failed</span>}</p>
      {c.recording_url ? <audio controls preload="none" src={c.recording_url} className="w-full h-8" data-testid={`jarvis-call-audio-${c.call_id}`} /> : <p className="text-[11px] text-gray-500">No recording</p>}
      {c.transcript && <button onClick={() => setOpen(!open)} className="text-cyan-300 text-[11px]" data-testid={`jarvis-call-transcript-btn-${c.call_id}`}>{open ? "Hide" : "Show"} transcript</button>}
      {open && <pre className="whitespace-pre-wrap text-[11px] text-gray-400 max-h-60 overflow-y-auto rounded-lg bg-black/40 p-2" data-testid={`jarvis-call-transcript-${c.call_id}`}>{c.transcript}</pre>}
    </div>
  );
};

export const CallLog = ({ phones, testid }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const key = phones.join(",");
  useEffect(() => {
    if (!key) return setItems([]);
    const t = setTimeout(() => apiGet("/admin/jarvis/contact-calls", { phones: key, ...(q ? { q } : {}) }).then((d) => setItems(d.items)).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [key, q]);
  if (!key || (items && !items.length && !q)) return null;
  return (
    <div className="space-y-2" data-testid={`jarvis-calls-${testid}`}>
      <div className="flex items-center gap-2">
        <p className={`${HUD.label} flex-1`}>AI calls {items ? `(${items.length})` : ""}</p>
        <div className="relative">
          <Search className="w-3.5 h-3.5 text-gray-500 absolute left-2 top-2.5" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search calls…" className={`h-8 w-48 rounded-lg pl-7 pr-2 text-xs border ${HUD.input}`} data-testid={`jarvis-calls-search-${testid}`} />
        </div>
      </div>
      <div className="rounded-lg border border-cyan-400/10 divide-y divide-cyan-400/5 max-h-96 overflow-y-auto">
        {items && items.length === 0 ? <p className="p-2 text-gray-500">No calls match.</p> : (items || []).map((c) => <Call key={c.call_id} c={c} />)}
      </div>
    </div>
  );
};
